import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconTick = ({ t, className, height, width, fill, background = 'none' }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 35 28'>
    <title>{t('Tick')}</title>
    <g transform='translate(-2 -6)' fill={background} fillRule='evenodd'>
      <rect width={39} height={39} rx={5} />
      <path
        d='M36.192 6.808a2.758 2.758 0 0 0-3.9 0L12.49 26.609l-5.759-5.897a2.76 2.76 0 0 0-3.947 3.853l7.708 7.896c.515.527 1.22.826 1.958.832h.016a2.76 2.76 0 0 0 1.95-.809l21.775-21.776a2.758 2.758 0 0 0 0-3.9'
        fill={fill}
      />
    </g>
  </svg>
)

export default Icon(IconTick)
